import React, { ChangeEvent, ReactNode, useEffect, useState } from 'react';
import { cx } from '@linaria/core';
import { Badge } from '../Badge';
import { CaptionStyles, FieldStyles, FieldWrapperStyles, InputGroupStyles, InputLabelStyles, InputTextStyles } from '../InputText/styles';
interface Props {
  id: string;
  name: string;
  value?: string | number;
  label?: string;
  caption?: ReactNode;
  isValid?: boolean;
  isInvalid?: boolean;
  isPrivate?: boolean;
  onChange?: (value: string, event: ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  autoComplete?: string;
  className?: string;
  dataId?: string;
  textTransformType?: React.CSSProperties['textTransform'];
  inputHeight?: number;
  isResizable?: boolean;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
}
const DEFAULT_INPUT_HEIGHT = 124;
const customFieldStyles = "c1gn1vr";
const customWithIcon = "c1selhms";
const customInputLabelStyles = "c2zvgbd";
const customIsInvalid = "c1og9ixi";
const textareaReset = "t106ghnz";
export const InputTextarea = ({
  id,
  name,
  value,
  label,
  caption,
  isValid = false,
  isInvalid = false,
  isPrivate = false,
  onChange,
  onFocus,
  onBlur,
  autoComplete,
  className,
  dataId,
  textTransformType,
  inputHeight = DEFAULT_INPUT_HEIGHT,
  isResizable = true,
  disabled = false,
  required = false,
  readOnly = false
}: Props) => {
  const [isFilled, setIsFilled] = useState(Boolean(value));
  useEffect(() => {
    setIsFilled(Boolean(value));
  }, [value]);
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setIsFilled(Boolean(event.target.value));
    onChange?.(event.target.value, event);
  };
  const handleFocus = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    onFocus?.(event);
  };
  const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
    onBlur?.(event);
  };
  return <div className={cx(FieldWrapperStyles, className)}>
      <label htmlFor={id} className={cx(FieldStyles, customFieldStyles, isInvalid && '__isInvalid', isInvalid && customIsInvalid, isFilled && '__isFilled', disabled && '__isDisabled', isResizable && '__isResizable', readOnly && '__isReadOnly')}>
        <div className={InputGroupStyles}>
          <textarea id={id} name={name} value={value} disabled={disabled} readOnly={readOnly} required={required} autoComplete={autoComplete} data-id={dataId} className={cx(InputTextStyles, textareaReset, isPrivate && 'fs-mask')} style={{
          textTransform: textTransformType,
          height: inputHeight
        }} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} />
          {label && <span className={cx(InputLabelStyles, 'label', customInputLabelStyles, disabled && '__isDisabled', isInvalid && '__isInvalid')}>
              {label}
              {required && <span className="asterisk">*</span>}
            </span>}
        </div>
        {isValid && <Badge size="xs" variant="success" iconName="Checkmark" className={customWithIcon} />}
        {isInvalid && <Badge size="xs" variant="danger" iconName="WarningMark" className={customWithIcon} />}
      </label>
      {caption && <div className={cx(CaptionStyles, isInvalid && '__isInvalid', disabled && '__isDisabled')}>
          {caption}
        </div>}
    </div>;
};

require("./InputTextarea.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./InputTextarea.tsx");